var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Base',{attrs:{"show-toolbar":false,"show-topbar":_vm.serverMode,"minimal-topbar":true,"topbar-z-index":1000}},[_c('v-row',[_c('v-col',{attrs:{"center":"","xl":"8","md":"8","sm":"12","xs":"12"}},[_c('UploadNexus',{attrs:{"retain-focus":"","persistent":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }